var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.loading
        ? _c("tree-item", {
            staticClass: "item mt-3",
            attrs: {
              item: _vm.tree,
              selected: _vm.selectedGroup,
              groupMood: _vm.groupMood
            },
            on: {
              "get-children": _vm.getChildren,
              "edit-group": _vm.editGroup,
              "add-group": _vm.addGroup,
              "add-office": _vm.addOffice,
              "add-user": _vm.addUser,
              "add-massive-users": _vm.addMassiveUsers,
              "remove-user": _vm.removeUser,
              "remove-group": _vm.removeGroup,
              "leader-group": _vm.leaderGroup,
              "add-sub-group": _vm.addSubGroup,
              "users-group": _vm.usersGroup,
              "config-numeration": _vm.configNumeration,
              "config-entity-doc-digital": _vm.entityDocDigital
            }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-flex justify-content-center" },
        [
          _vm.loading
            ? _c("b-spinner", {
                staticClass: "mt-4",
                attrs: { variant: "primary", size: "sm" }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "numeration",
          attrs: {
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Numeración para el grupo " + _vm.selectedGroup.nombre
          }
        },
        [
          _vm.selectedGroup
            ? _c("NumerationConfig", { attrs: { group: _vm.selectedGroup } })
            : _vm._e()
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "group",
          attrs: {
            centered: "",
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: _vm.groupMood
              ? "Datos del grupo " + _vm.selectedGroup.nombre
              : "Datos de la oficina"
          }
        },
        [
          _vm.selectedGroup && _vm.action && !_vm.manageOffice
            ? _c("manage-group", {
                attrs: {
                  group: _vm.selectedGroup,
                  name: _vm.selectedGroup.nombre,
                  action: _vm.action
                },
                on: { "close-action": _vm.closeModal }
              })
            : _vm._e(),
          _vm.selectedGroup && _vm.action && _vm.manageOffice
            ? _c("manage-office", {
                attrs: {
                  group: _vm.selectedGroup,
                  name: _vm.selectedGroup.nombre,
                  action: _vm.action,
                  "data-cy": "manage-office"
                },
                on: { "close-action": _vm.closeModal }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "user",
          attrs: {
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Datos del usuario",
            noCloseOnEsc: "",
            centered: ""
          }
        },
        [
          _c("manage-user", {
            attrs: {
              action: _vm.actionUser,
              user: _vm.user,
              group: _vm.selectedGroup
            },
            on: { "close-manage-user": _vm.closeModal }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "manageMassiveUsersModal",
          attrs: {
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Acción Masiva",
            noCloseOnEsc: "",
            centered: ""
          }
        },
        [
          _c("manage-massive-users", {
            on: { "close-manage-massive-users": _vm.cerrarModalMasivoYToast }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "removeUser",
          attrs: {
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Datos del usuario"
          }
        },
        [
          _c("remove-user", {
            attrs: { action: _vm.actionUser, user: _vm.user },
            on: { "close-action": _vm.closeModal }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "removeGroup",
          attrs: {
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Remover grupo/oficina"
          }
        },
        [
          _c("remove-group", {
            attrs: { action: _vm.action, group: _vm.selectedGroup },
            on: { "close-action": _vm.closeModal }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "groupUsers",
          attrs: {
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Usuarios del grupo"
          }
        },
        [
          _c("users-group", {
            attrs: { usersGeneral: _vm.usersGeneral, group: _vm.selectedGroup }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "leaderGroup",
          attrs: {
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Líder para el grupo " + _vm.selectedGroup.nombre
          }
        },
        [
          _c("leader-form", {
            attrs: { group: _vm.selectedGroup },
            on: { "close-action": _vm.closeModal }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "configEntityDocDigital",
          attrs: {
            centered: "",
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Configurar entidad Doc Digital"
          },
          on: { "close-action": _vm.closeModal }
        },
        [
          _c("entity-doc-digital-form", {
            attrs: {
              group: _vm.selectedGroup,
              "data-cy": "entity-doc-digital-form"
            },
            on: { "close-action": _vm.closeModal }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }